import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PillComponent } from './pill.component';
import { IconModule } from '../icon/icon.module';
import { CloseActionModule } from '../close-action/close-action.module';

@NgModule({
  declarations: [PillComponent],
  imports: [CommonModule, IconModule, CloseActionModule],
  exports: [PillComponent],
})
export class PillModule {}
